import { EventEmitterService } from '@core/services/event-emitter.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Pagination } from '@core/models/pagination.model';
import { map, exhaustMap, tap } from 'rxjs/operators';
import { FormGroup, FormControl } from '@angular/forms';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { PaymentGatewayBotDataService } from './service/payment-gateway-bot-data.service';
import { PaymentGatewayBotEntityService } from '@views/pages/apps/settings/payment-gateway-bot/service/payment-gateway-bot-entity.service';
import { Component, OnInit, OnDestroy, ChangeDetectorRef} from '@angular/core';
import { Observable, of, Subscription,timer } from 'rxjs';
import Swal from 'sweetalert2';
import { PaymentGatewayBot } from '@core/models/payment-gateway-bot.model';
import { AppPermissionService } from '@core/services/app-permission.service';
import * as moment from 'moment-timezone';
import { TransactionHttpService } from '@core/services/transaction-http.service';;
import { expand,delayWhen } from 'rxjs/operators';
import { DateTime } from 'luxon';
import { catchError, timeout } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { PGReconciliationJobCreateComponent } from './dialogs/pg-reconciliation-job-create.component';

@Component({
  selector: 'kt-payment-gateway-bot',
  templateUrl: './payment-gateway-bot.component.html',
  styleUrls: ['./payment-gateway-bot.component.scss']
})
export class PaymentGatewayBotComponent implements OnInit, OnDestroy {

  form: FormGroup;
  dropdown = {
    perPage: this.dropdownHttpService.perPage
  };
  paymentGatewayBot$: Observable<PaymentGatewayBot[]>;
  statuses = [
    "Disabled",
    "Enabled"
  ];
  currencies = (JSON.parse(sessionStorage.getItem('currencies')) || []).map((currency: any) => currency.name);

  pagination: Pagination;
  pageSize = 30;
  page = 1;
  maxSize = 5;
  params = '';
  data = [];
  callApi = [];

  loading = false;
  clearBtnLoading = false;
  searchBtnLoading = false;
  dataLength = 0;

  messages$ = this.paymentGatewayBotDataService.messages$;

  // permissions
  canEnterTAC: boolean;
  canUpdateBankBotStatus: boolean;
  canCreateReconciliationJob: boolean;

  private subscription = new Subscription();
  private subscriptions = new Subscription();
  private apiSubscription = new Subscription();

  dateTimePickerLocale = this.transactionHttpService.dateTimePickerLocale;
  timezone = JSON.parse(localStorage.getItem('user_data')).timezone;
  ranges: any;

  dateTimeFilterType = [
    {
      key: 'last_run_at',
      label: 'Last Run Date'
    },
    {
      key: 'created_at',
      label: 'Created Date'
    },
    {
      key: 'updated_at',
      label: 'Updated Date'
    }
  ];

  constructor(
    private paymentGatewayBotEntityService: PaymentGatewayBotEntityService,
    private paymentGatewayBotDataService: PaymentGatewayBotDataService,
    private dropdownHttpService: DropdownHttpService,
    private loadingBar: LoadingBarService,
    private eventEmitterService: EventEmitterService,
    private appPermissionService: AppPermissionService,
    private transactionHttpService: TransactionHttpService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.reload();
    this.formInit();
    this.pagination = this.paymentGatewayBotDataService.pagination;

    const apSub = this.appPermissionService.getAppPermissions().subscribe(appPermissions => {
      this.canUpdateBankBotStatus = appPermissions.update_payment_gateway_bot_status;
      this.canCreateReconciliationJob = appPermissions.create_payment_gateway_bot_reconciliation_job;
    });

    this.subscriptions.add(apSub);
  }

  ngOnDestroy() {
    this.apiSubscription.unsubscribe();
    this.subscription.unsubscribe();
    this.subscriptions.unsubscribe();
  }

  onViewPageBy(page = 1, pageSize?: number, params?: string) {
    this.loading = true;
    pageSize = this.pageSize;
    params = this.params ? `&${this.params}` : '';
    this.loadingBar.start();
    return this.paymentGatewayBot$ = this.paymentGatewayBotEntityService.getWithQuery(`?page=${page}&perPage=${pageSize}${params}`).pipe(
      tap(res => {
        this.loading = false;
        this.dataLength = res.length;
        this.pagination = this.paymentGatewayBotDataService.pagination;
        this.loadingBar.complete();
      })
    );
  }

  onPerPage(size: Event) {
    this.pageSize = +(size.target as HTMLSelectElement).value;
    this.onViewPageBy(this.page, this.pageSize, this.params);
  }

  onCloseDialog() {
  }

  onClear() {
    // this.bankaccountSelectedItems = [this.bankaccountDropdownList.find(v => v.id === 'all')];
    this.clearBtnLoading = true;
    this.eventEmitterService.onClearMerchantAccountSearch();
    this.form.patchValue({
      // merchant_bank_id: 'all',
      currency_code: '',
      start_date: null,
      end_date: null,
      defaultDate: null,
      date_type: this.dateTimeFilterType[0].key
    });
    this.onSubmit(true);
  }

  onSubmit(clearSearch?: boolean) {
    this.searchBtnLoading = clearSearch ? false : true;
    this.loading = true;
    of(this.form.value).pipe(
      map(this.filterFormFields),
      exhaustMap((data) => {
        // add 8 hour, bant bot +8 timezone
        if (data['start_date']) {
          data['start_date'] = moment(data['start_date']).add(8, 'hours').tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
          data['end_date'] = moment(data['end_date']).add(8, 'hours').tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
        }
        if(data['defaultDate']){
          delete data['defaultDate'];
        }
        this.params = Object.keys(data).map(key => key + '=' + data[key]).join('&');
        const parameters = this.params ? `&${this.params}` : '';
        this.loadingBar.start();
        return this.paymentGatewayBot$ = this.paymentGatewayBotEntityService.getWithQuery(`?perPage=${this.pageSize}${parameters}`).pipe(
          tap(res => {
            this.loading = false;
            this.clearBtnLoading = false;
            this.searchBtnLoading = false;
            this.dataLength = res.length;
            this.page = 1;
            this.pagination = this.paymentGatewayBotDataService.pagination;
            this.loadingBar.complete();
          })
        );
      }),
    ).subscribe();
  }

  private formInit() {
    this.form = new FormGroup({
      // merchant_bank_id: new FormControl('all'),
      currency_code: new FormControl(''),
      date_type: new FormControl(this.dateTimeFilterType[0].key),
      start_date: new FormControl(null),
      end_date: new FormControl(null),
      defaultDate: new FormControl(null)
    });
  }

  private filterFormFields(formData: any) {
    const fields = {};
    Object.keys(formData).forEach(key => (formData[key] !== '' && formData[key] !== null && key !== 'defaultDate') ? fields[key] = formData[key] : key);
    return fields;
  }

  reload() {
    this.onViewPageBy(this.page).subscribe();
  }

  updateSwitch(row: any, value: number) {
    if (row.switch !== value) {
      const data = {
        switch: value
      };
      this.subscription = this.paymentGatewayBotDataService.updateSwitch(row.id, data).subscribe(() =>
        this.messages$ = this.paymentGatewayBotDataService.messages$
      );
    }
  }

  updateTAC(payment_gateway_bot_id: number) {
    Swal.fire({
      title: 'Enter TAC',
      input: 'text',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        let data = {
          payment_gateway_bot_id: payment_gateway_bot_id,
          tac: result.value
        }
        this.paymentGatewayBotDataService.updateTAC(data).subscribe(() =>
          this.messages$ = this.paymentGatewayBotDataService.messages$
        );
      }
    })
  }

  getTAC(key: string, id: number) {
    let data = {};
    data['key'] = key;
    if(!this.callApi["pg-"+id])  this.callApi["pg-"+id] = false;
    if(!this.data["pg-"+id])     this.data["pg-"+id] = null;

    if(this.callApi["pg-"+id] == false){
      this.callApi["pg-"+id] = true;
      of(null).pipe(
        expand(() =>
          this.paymentGatewayBotDataService.getTAC(data).pipe(
            delayWhen(() => timer(30000)) // Wait 30 seconds before next call
          )
        ),
        catchError((error) => {
          this.callApi["pg-"+id] = true;
          delayWhen(() => timer(30000)) // Wait 30 seconds before next call
          throw error;
        })
      ).subscribe(response => {
        if(response){
          this.data["pg-"+id] = response;
          this.cdr.detectChanges();
        }
        this.callApi["pg-"+id] = true;
      });
    }

  }

  onClearDate() {
    if (this.form.value.start_date !== null) {
      this.form.patchValue({ defaultDate: null });
    }
  }

  onDateRange(event: any) {
    if (event) {
      this.form.patchValue({
        start_date: event.startDate !== null && event.startDate !== undefined ? event.startDate : null,
        end_date: event.endDate !== null && event.endDate !== undefined ? event.endDate : null
      });
    }
  }

  updateDateRange() {
    this.ranges = this.transactionHttpService.updateDateRange();
  }

  isValidDate(date: Date | string) {
    if (moment(date).isValid()) {
      return true;
    }
    return false;
  }

  onOpenDialog() {  
    this.openDialogBy(PGReconciliationJobCreateComponent);  
  }

  private openDialogBy(componentRef: any) {
    const dialogRef = this.dialog.open(componentRef, {
      width: '800px',
      height: 'auto'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.reload();
      }
    });
  }
}
